import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { RouteHistoryProvider } from './components/RoutehistoryContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouteHistoryProvider>
    <App />
    </RouteHistoryProvider>
  </React.StrictMode>
);


